import { render, staticRenderFns } from "./IntegrationLogHistoryModal.vue?vue&type=template&id=1c0b6ed3&"
import script from "./IntegrationLogHistoryModal.vue?vue&type=script&lang=js&"
export * from "./IntegrationLogHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationLogHistoryModal.vue?vue&type=style&index=0&id=1c0b6ed3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports